import * as React from "react";
import SelectComponent from "../../../ui/select/SelectComponent";
import QuoteEmailTemplate from "../../../../model/partnerBrand/QuoteEmailTemplate";

export class SelectTemplate extends SelectComponent<QuoteEmailTemplate> {
	matchFilter(element: QuoteEmailTemplate, filter: string): boolean {
		return element.name.indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: QuoteEmailTemplate): string {
		return element.id;
	}

	elementToString(element: QuoteEmailTemplate) {
		return element.name;
	}
}
